import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=57aae500&scoped=true&"
import script from "./Summary.vue?vue&type=script&lang=js&"
export * from "./Summary.vue?vue&type=script&lang=js&"
import style0 from "./Summary.vue?vue&type=style&index=0&id=57aae500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aae500",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Proyects\\Happybox\\happyboxstore-repo\\email-shipping\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57aae500')) {
      api.createRecord('57aae500', component.options)
    } else {
      api.reload('57aae500', component.options)
    }
    module.hot.accept("./Summary.vue?vue&type=template&id=57aae500&scoped=true&", function () {
      api.rerender('57aae500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "EmailShipping/components/Summary.vue"
export default component.exports